function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_1_",
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18 14h-11c-3.309 0-6 2.691-6 6v37c0 3.309 2.691 6 6 6h11c.553 0 1-.448 1-1v-4c0-.552-.447-1-1-1h-10c-.552 0-1-.449-1-1h12v-2h-12v-1h12v-2h-12v-1h12v-2h-12v-1h12v-2h-12v-1h12v-2h-12v-1h12v-2h-12v-1h12v-2h-12v-1h12v-2h-12v-1h12v-2h-12v-1h12v-2h-12v-1h12v-2h-12v-1h12v-2h-12c0-.551.448-1 1-1h10c.553 0 1-.448 1-1v-4c0-.552-.447-1-1-1zm-1 4h-9c-1.654 0-3 1.346-3 3v35c0 1.654 1.346 3 3 3h9v2h-10c-2.206 0-4-1.794-4-4v-37c0-2.206 1.794-4 4-4h10z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 48c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm0 10c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.104 45.047-5.191-10.165 7.064-32.671c.106-.491-.169-.985-.642-1.153-.47-.167-.998.04-1.227.487l-11.108 21.756-11.109-21.756c-.228-.449-.757-.655-1.227-.487-.473.169-.748.662-.642 1.153l7.064 32.671-5.191 10.165c-5.351-.568-9.895 3.694-9.895 8.953 0 4.962 4.037 9 9 9s9-4.038 9-9c0-2.237-.851-4.405-2.354-6.056l2.841-5.68c.532-1.064 1.424-1.859 2.515-2.303 1.058.432 1.971 1.222 2.512 2.303l2.841 5.68c-1.504 1.651-2.355 3.819-2.355 6.056 0 4.962 4.037 9 9 9s9-4.038 9-9c0-5.259-4.548-9.521-9.896-8.953zm-1.703-35.758-4.925 22.778-3.353-6.567zm-16.865 38.401c-.198.397-.111.878.215 1.181 1.45 1.344 2.249 3.166 2.249 5.129 0 3.86-3.141 7-7 7s-7-3.14-7-7 3.141-7 7-7c.414 0 .832.04 1.279.123.432.079.871-.134 1.072-.529l4.403-8.622.268 1.24c.062.288.248.533.508.671.261.138.567.153.841.046.131-.052.266-.076.399-.116-.421.462-.785.982-1.073 1.557zm19.464 13.31c-3.859 0-7-3.14-7-7 0-1.963.799-3.785 2.249-5.129.326-.302.413-.783.215-1.181l-3.161-6.321c-1.187-2.373-3.629-3.781-6.161-3.781-.464 0-.93.047-1.393.144l-6.15-28.444 19.05 37.306c.2.393.636.608 1.072.529.447-.083.865-.123 1.279-.123 3.859 0 7 3.14 7 7s-3.141 7-7 7z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 48c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm0 10c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 34h2v2h-2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalon);
export default __webpack_public_path__ + "static/media/salon.472a5a95949de7abcddcf0e4ef7ee01d.svg";
export { ForwardRef as ReactComponent };